export enum ClientCode {
  AEG = '00004',
  Amana = '00009',
  Amica = '00010',
  Baumatic = '00029',
  Beko = '00034',
  Belling = '00035',
  Blomberg = '00045',
  Bush = '00056',
  Candy = '00061',
  Cannon = '00062',
  Cda = '00000',
  Creda = '00077',
  Flavel = '00148',
  Grundig = '00129',
  Haier = '00118',
  Hoover = '00151',
  Hotpoint = '00154',
  Indesit = '00170',
  LEC = '00191',
  Leisure = '00147',
  LG = '00194',
  Matrix = '00263',
  Maytag = '00214',
  MiraShowers = '00225',
  Stoves = '00310',
  Whirlpool = '00343',
  Zenith = '00161',
}
